import {ArrowPathIcon, MapPinIcon, UsersIcon} from "@heroicons/react/24/outline";
import {CREDITS_CLASSES} from "pages/Front/Booking/Credits/CreditCalculator/constants";
import React from "react";

export function CreditRuleCards() {
    return (
        <div className="grid grid-cols-1 gap-2 sm:grid-cols-3">
            <section className="rounded-lg bg-panel px-3.5 py-3 text-xs leading-relaxed">
                <h4 className="mb-1 flex items-center gap-1.5 font-semibold text-ink">
                    <MapPinIcon className="h-4 w-4" aria-hidden="true" />
                    Entscheide im Park
                </h4>
                <p className="text-ink-secondary">
                    Beim Kauf wählst du nur die Menge. Welche Fahrten du machst, entscheidest du vor Ort — spontan, an der Attraktion.
                </p>
            </section>

            <section className="rounded-lg bg-panel px-3.5 py-3 text-xs leading-relaxed">
                <h4 className="mb-1 flex items-center gap-1.5 font-semibold text-ink">
                    <ArrowPathIcon className="h-4 w-4" aria-hidden="true" />
                    Credits verfallen nie
                </h4>
                <p className="text-ink-secondary">Übrige Credits bleiben im Konto und warten auf den nächsten Besuch. Zu viel gekauft gibt es nicht.</p>
            </section>

            <section className={`rounded-lg border px-3.5 py-3 text-xs leading-relaxed ${CREDITS_CLASSES.border}`}>
                <h4 className={`mb-1 flex items-center gap-1.5 font-semibold ${CREDITS_CLASSES.text}`}>
                    <UsersIcon className="h-4 w-4" aria-hidden="true" />
                    Teilen? Familien &amp; Kindergeburtstage.
                </h4>
                <p className="text-ink-secondary">
                    Mit dem Family Ticket und den Happy Kids Packages ist das Guthaben gemeinsam — auf Wunsch mit Credit-Limits pro Person. Bei allen anderen
                    Tickets sind Credits persönlich.
                </p>
            </section>
        </div>
    );
}
